import {
  FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_REQUEST,
  FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_SUCCESS,
  FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_FALUIRE,
} from './getProjectTemplateSubTaskByIDTypes'

const initialState = {
  loading: false,
  unitAreaForThermit: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_SUCCESS : return {
      ...state,
      unitAreaForThermit: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_FALUIRE : return {
      ...state,
      loading: false,
      unitAreaForThermit: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
